import React from 'react';
import { Link } from 'react-router-dom';
import LogoTray from './LogoTray';
import DeleteAccount from './DeleteAccount';

export default function DeleteAccountPage() {
  return <div className="postavke-container">
    <LogoTray />
    <main className="postavke-content">
      <h1>JaoSVE · Brisanje računa</h1>
      {localStorage.getItem('token') ? <DeleteAccount /> : <p><Link to="/login" state={{ returnTo: '/delete-account' }}>Prijavite se za brisanje računa</Link></p>}
    </main>
  </div>;
}
